export default "__VITE_ASSET__496c0557__"